import { AuthorisationRight } from './authorisation-rights.const';

export enum BackgroundType {
  IMAGE = 'image',
  LOTTIE = 'lottie',
}

export class Font {
  family?: string;
  ratio?: number;
  letterSpacing?: number;
  src?: string;
  cssName?: string;

  constructor(font?: Font) {
    if (font) {
      this.family = font.family;
      this.ratio = font.ratio;
      this.letterSpacing = font.letterSpacing;
      this.src = font.src;

      if (font.family) {
        this.cssName = Font._escapeFontName(font.family);
      }
    }
  }

  private static _escapeFontName(fontName: string): string {
    return fontName
      .split(',')
      .map(
        f =>
          `"${f
            .trim()
            .replace(/^['"]|['"]$/gm, '')
            .replace('"', '\\"')}"`,
      )
      .join(', ');
  }
}

export enum BackgroundSize {
  COVER = 'cover',
  CONTAIN = 'contain',
  NORMAL = 'inherit',
}

export enum BackgroundRepeat {
  REPEAT = 'repeat',
  REPEAT_X = 'repeat-x',
  REPEAT_Y = 'repeat-y',
  NO_REPEAT = 'no-repeat',
}

export enum BackgroundPosition {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',

  LEFT_TOP = 'left top',
  LEFT_CENTER = 'left center',
  LEFT_BOTTOM = 'left bottom',

  TOP_LEFT = 'top left',
  TOP_RIGHT = 'top right',
  TOP_CENTER = 'top center',

  BOTTOM_LEFT = 'bottom left',
  BOTTOM_RIGHT = 'bottom right',
  BOTTOM_CENTER = 'bottom center',

  RIGHT_TOP = 'right top',
  RIGHT_CENTER = 'right center',
  RIGHT_BOTTOM = 'right bottom',

  CENTER_RIGHT = 'center right',
  CENTER_LEFT = 'center left',
  CENTER_TOP = 'center top',
  CENTER_BOTTOM = 'center bottom',
}

export class CustomImage {
  type: BackgroundType;
  src: string;
  alt?: string;
  right?: AuthorisationRight[];
  cssProperties?: {
    backgroundSize?: BackgroundSize | null;
    backgroundRepeat?: BackgroundRepeat | null;
    backgroundPosition?: BackgroundPosition | null;
  };

  constructor(image?: CustomImage) {
    this.type = image?.type || null;
    this.src = image?.src || null;
    this.alt = image?.alt || null;
    this.right = image?.right || null;
    this.cssProperties = image?.cssProperties ?? {
      backgroundSize: null,
      backgroundRepeat: null,
      backgroundPosition: null,
    };
  }
}

export class CustomSound {
  src: string;
  soundName?: string;

  constructor(sound?: CustomSound) {
    this.src = sound?.src || null;
  }
}

export enum SoundType {
  GAME = 'gameSound',
  AMBIANCE = 'ambianceSound',
}
